export default {
  title: 'Components batch 1/Chip',
  tags: ['autodocs'],
  argTypes: {
    text: {
      control: 'text',
      description: 'Text to display inside the chip',
    },
    bg_color: {
      control: { type: 'select' },
      options: ['grey', 'primary', 'green', 'yellow', 'red', 'purple'],
      description: 'Background color of the chip',
    },
    size: {
      control: { type: 'select' },
      options: ['sm', 'md', 'lg'],
      description: 'Select the size of the chip',
    },
    icon: {
      control: 'text',
      description: 'Font Awesome icon class to display at the start of the chip',
    },
    show_close_icon: {
      control: 'boolean',
      description: 'Whether to show a close icon at the end of the chip',
    },
    rounded: {
      control: { type: 'select' },
      options: ['sm','circle'],
      description: 'Define the roundedness of the chip',
    },
    custom_class: {
      control: { type: 'text' }, // Add control for custom class
      description: 'Custom class for the chip',
    },
    component_mode :{
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the chip component',
    }
  },
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-chip\` component, pass the following props:

\`\`\`html
<dda-chip
    bg_color="grey"
    icon="fa fa-smile"
    show_close_icon="true"
    custom_class=""
    component_mode=""
    ><!---->Label
</dda-chip>
  \`\`\`
`,
      },
    },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `<dda-chip ${attributes}>${args.text}</dda-chip>`;
};

export const Grey = Template.bind({});
Grey.args = {
  text: 'Label',
  bg_color: 'grey',
  icon: 'fa-regular fa-face-smile',
  show_close_icon: true,
  custom_class: '',
  component_mode: ''
};

export const Primary = Template.bind({});
Primary.args = {
  text: 'Label',
  bg_color: 'primary',
  icon: 'fa-regular fa-face-smile',
  show_close_icon: true,
  custom_class: '',
  component_mode: ''
};

export const Green = Template.bind({});
Green.args = {
  text: 'Label',
  bg_color: 'green',
  icon: 'fa-regular fa-face-smile',
  show_close_icon: true,
  custom_class: '',
  component_mode: ''
};

export const Yellow = Template.bind({});
Yellow.args = {
  text: 'Label',
  bg_color: 'yellow',
  icon: 'fa-regular fa-face-smile',
  show_close_icon: true,
  custom_class: '',
  component_mode: ''
};

export const Red = Template.bind({});
Red.args = {
  text: 'Label',
  bg_color: 'red',
  icon: 'fa-regular fa-face-smile',
  show_close_icon: true,
  custom_class: '',
  component_mode: ''
};

export const Purple = Template.bind({});
Purple.args = {
  text: 'Label',
  bg_color: 'purple',
  icon: 'fa-regular fa-face-smile',
  show_close_icon: true,
  custom_class: '',
  component_mode: ''
};